// WordCounter.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Penghitung Kata dan Huruf - Hitung Jumlah Kata dan Huruf dalam Teks";
const DESCRIPTION =
  "Hitung jumlah kata dan huruf dalam kalimat tertentu menggunakan kalkulator sederhana ini. Kalkulator ini menyediakan cara cepat dan akurat untuk mengetahui jumlah kata dan huruf dalam teks apa pun yang Anda tulis.";
const KEYWORDS = "kalkulator, jumlah, kata, teks, kalimat, hitung, huruf, jumlah kata, jumlah huruf";
const OG_URL = "https://do-calculate.com/calculator/id/word-counter/";
function WordCounter() {
  const [sentence, setSentence] = useState("");
  const [wordCount, setWordCount] = useState(null);
  const [charCount, setCharCount] = useState(0);
  const [letterCount, setLetterCount] = useState(0);
  const [error, setError] = useState("");
  const calculateWordCount = () => {
    try {
      if (sentence.trim() === "") {
        setError("Silakan masukkan kalimat untuk menghitung jumlah kata");
        return;
      }
      setCharCount(sentence.length);
      setLetterCount(sentence.replace(/\s+/g, "").length);
      const words = sentence.trim().split(/\s+/).length;
      setWordCount(words);
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator ini menyediakan cara sederhana dan cepat untuk menghitung jumlah kata dalam kalimat
                  atau teks tertentu. Mengetahui jumlah kata dapat berguna dalam berbagai konteks,
                  seperti menentukan jumlah kata dalam artikel, memenuhi persyaratan penulisan,
                  atau bahkan meningkatkan keterampilan menulis Anda. Alat ini dapat digunakan untuk
                  membantu Anda memperkirakan ukuran teks dan merencanakan konten tulisan
                  dengan lebih akurat.
                </p>
                <p>
                  Misalnya, jika Anda sedang menulis artikel dan perlu memastikan bahwa artikel tersebut
                  memiliki jumlah kata tertentu, Anda dapat memasukkan teks ke dalam kalkulator ini untuk mengetahui
                  jumlah total kata. Ini dapat membantu Anda memeriksa seberapa baik Anda mematuhi
                  persyaratan penulisan atau bahkan menganalisis teks untuk menentukan tingkat kepadatannya.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="sentence">Masukkan kalimat:</label>
                    <textarea
                      id="sentence"
                      value={sentence}
                      onChange={(e) => setSentence(e.target.value)}
                      className="form-control"
                      style={{ width: "75%", height: "100px" }}
                    />
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                    onClick={calculateWordCount}
                  >
                    Hitung
                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">Error: {error}</p>
                ) : (
                  wordCount !== null && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <p>Jumlah kata: {wordCount}</p>
                      <p>Jumlah huruf dengan spasi: {charCount}</p>
                      <p>Jumlah huruf tanpa spasi: {letterCount}</p>
                    </div>
                  )
                )}
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Cara Menghitung Jumlah Kata</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Langkah 1: Masukkan Teks</h2>
                  </u>
                  <p>
                    Pertama, Anda perlu memasukkan kalimat atau teks yang ingin Anda hitung
                    jumlah katanya. Pastikan untuk memasukkan teks secara lengkap dan akurat untuk mendapatkan
                    perhitungan yang benar. Anda dapat memasukkan teks di kolom teks yang tersedia di
                    kalkulator. Langkah ini penting karena perhitungan bergantung pada teks yang
                    Anda masukkan.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Langkah 2: Mulai Perhitungan</h2>
                  </u>
                  <p>
                    Setelah memasukkan teks, tekan tombol "Hitung" untuk memulai proses perhitungan. Kalkulator akan
                    menganalisis teks dan menentukan jumlah kata yang ada di dalamnya berdasarkan
                    pemisahan teks menjadi kata-kata menggunakan spasi dan pemisah. Pastikan tidak ada
                    teks tambahan yang tidak perlu untuk memastikan akurasi perhitungan.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Langkah 3: Lihat Hasil</h2>
                  </u>
                  <p>
                    Setelah perhitungan selesai, kalkulator akan menampilkan jumlah kata dalam teks yang
                    Anda masukkan. Anda dapat menggunakan informasi ini untuk memeriksa seberapa baik
                    Anda mematuhi persyaratan jumlah kata yang ditentukan, atau untuk menganalisis teks Anda
                    dengan lebih akurat. Mengetahui jumlah kata dapat membantu Anda meningkatkan
                    keterampilan menulis dan menentukan seberapa komprehensif teks tersebut.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Contoh: Jika Anda memasukkan teks "Halo, apa kabar hari ini?" kalkulator akan menampilkan
                    bahwa jumlah kata adalah 5 kata.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Langkah 4: Gunakan Jumlah Kata
                    </h2>
                  </u>
                  <p>
                    Setelah mengetahui jumlah kata, Anda dapat menggunakan informasi ini untuk berbagai
                    tujuan seperti mengatur konten, memeriksa kepatuhan terhadap persyaratan
                    penulisan, atau meningkatkan teks. Alat ini dapat berguna dalam menulis artikel,
                    menyiapkan laporan, atau teks lain yang memerlukan pelacakan jumlah kata yang akurat.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Contoh: Jika Anda sedang menulis artikel dan perlu menentukan jumlah kata di dalamnya
                    untuk memastikan kepatuhan terhadap persyaratan publikasi, Anda dapat menggunakan kalkulator untuk mengetahui
                    jumlah akhir.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default WordCounter;